import { ROUTES } from 'src/constants/routes';

export interface SearchResult {
    title: string;
    path: string;
    category: string;
    subtitle?: string;
}

export const SEARCHABLE_ITEMS: SearchResult[] = [
    {
        title: 'Vendors',
        path: ROUTES.VENDORS.INDEX,
        category: 'Labels',
        subtitle: 'Manage music label vendors and contacts'
    },
    {
        title: 'Add Vendor',
        path: ROUTES.VENDORS.INDEX + ROUTES.VENDORS.ADD,
        category: 'Labels',
        subtitle: 'Create a new vendor record'
    },
    { title: 'Deals', path: ROUTES.DEALS.INDEX, category: 'Labels', subtitle: 'View and manage licensing deals' },
    {
        title: 'Add Deal',
        path: ROUTES.DEALS.INDEX + ROUTES.DEALS.ADD,
        category: 'Labels',
        subtitle: 'Create a new licensing deal'
    },
    {
        title: 'Rate Cards',
        path: ROUTES.RATE_CARDS.INDEX,
        category: 'Labels',
        subtitle: 'Manage royalty rate card contracts'
    },
    {
        title: 'Add Rate Card',
        path: ROUTES.RATE_CARDS.INDEX + ROUTES.RATE_CARDS.ADD,
        category: 'Labels',
        subtitle: 'Create a new rate card contract'
    },
    {
        title: 'Agreements',
        path: ROUTES.AGREEMENTS.INDEX,
        category: 'Labels',
        subtitle: 'Access contracts and related documents'
    },
    {
        title: 'Reporting',
        path: ROUTES.REPORTING.INDEX,
        category: 'Labels',
        subtitle: 'Real time royalties and MSS reporting'
    },
    {
        title: 'Paper Plans',
        path: ROUTES.PAPER_PLANS.INDEX,
        category: 'Resources',
        subtitle: 'Configure subscription plan royalty calculations'
    },
    {
        title: 'Add Paper Plan',
        path: ROUTES.PAPER_PLANS.INDEX + ROUTES.PAPER_PLANS.ADD,
        category: 'Resources',
        subtitle: 'Create a new paper plan configuration'
    },
    {
        title: 'Paper Plan Mappings',
        path: ROUTES.PAPER_PLAN_MAPPINGS.INDEX,
        category: 'Resources',
        subtitle: 'Map paper plans to subscription plans'
    },
    {
        title: 'Base Plan Launch Dates',
        path: ROUTES.BASE_PLAN_LAUNCH_DATES.INDEX,
        category: 'Resources',
        subtitle: 'Track subscription plan launch dates'
    },
    {
        title: 'Service Launches',
        path: ROUTES.SERVICE_LAUNCHES.INDEX,
        category: 'Resources',
        subtitle: 'Manage service and marketplace launches'
    },
    {
        title: 'Plan Weights',
        path: ROUTES.PLAN_WEIGHTS.INDEX,
        category: 'Resources',
        subtitle: 'Configure plan weighting for calculations'
    },
    {
        title: 'Bundle Pricing',
        path: ROUTES.BUNDLE_PRICING.INDEX,
        category: 'Resources',
        subtitle: 'Manage bundle pricing configurations'
    },
    {
        title: 'Review Paper Plans',
        path: ROUTES.REVIEW_PAPER_PLANS.INDEX,
        category: 'Resources',
        subtitle: 'Review and approve paper plan changes'
    },
    {
        title: 'Compare Contracts',
        path: ROUTES.COMPARE.CONTRACTS,
        category: 'Resources',
        subtitle: 'Compare rate card contract terms side-by-side'
    },
    {
        title: 'Compare Deals',
        path: ROUTES.COMPARE.DEALS,
        category: 'Resources',
        subtitle: 'Compare licensing deal terms side-by-side'
    },
    {
        title: 'Analytics',
        path: ROUTES.ANALYTICS.INDEX,
        category: 'Analytics',
        subtitle: 'View licensing KPIs and metrics dashboard'
    },
    {
        title: 'AMU Metrics',
        path: ROUTES.ANALYTICS.LICENSING_KPI.AMU_METRICS,
        category: 'Analytics',
        subtitle: 'Amazon Music Unlimited metrics and trends'
    },
    {
        title: 'Prime Metrics',
        path: ROUTES.ANALYTICS.LICENSING_KPI.PRIME_METRICS,
        category: 'Analytics',
        subtitle: 'Prime Music metrics and trends'
    },
    {
        title: 'AMF Metrics',
        path: ROUTES.ANALYTICS.LICENSING_KPI.AMF_METRICS,
        category: 'Analytics',
        subtitle: 'Amazon Music Free metrics and trends'
    },
    {
        title: 'AI Chat',
        path: ROUTES.AI.INDEX,
        category: 'AI',
        subtitle: 'Licensing AI with contract, royalties, and industry context'
    },
    {
        title: 'Settings',
        path: ROUTES.SETTINGS.INDEX,
        category: 'Settings',
        subtitle: 'Configure application preferences'
    }
];

export const searchSite = (query: string, entities?: any[]): SearchResult[] => {
    if (!query.trim()) return [];

    const lowerQuery = query.toLowerCase();
    const results: SearchResult[] = [];

    // Search static pages
    const pageResults = SEARCHABLE_ITEMS.filter(
        (item) => item.title.toLowerCase().includes(lowerQuery) || item.category.toLowerCase().includes(lowerQuery)
    );
    results.push(...pageResults);

    // Search vendors
    if (entities) {
        const vendorResults = entities
            .filter((entity) => {
                if (!entity.entityId) return false;
                const nameMatch = entity.entityName?.toLowerCase().includes(lowerQuery);
                const codeMatch = entity.entityVendorCodes?.some(
                    (code: any) =>
                        code.catalogVendorCode?.toLowerCase().includes(lowerQuery) ||
                        code.royaltyVendorCode?.toLowerCase().includes(lowerQuery)
                );
                return nameMatch || codeMatch;
            })
            .map((entity) => ({
                title: entity.entityName || '',
                subtitle: entity.entityVendorCodes?.[0]?.catalogVendorCode || '',
                path: `${ROUTES.VENDORS.INDEX}/${String(entity.entityId)}`,
                category: 'Vendor'
            }));
        results.push(...vendorResults);
    }

    return results.slice(0, 8);
};
